import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useLanguageTranslator } from "../../../components";
import { CountryIndex } from "./countryIndex";
import { CategoryIndex } from "./categoryIndex";
import { useState } from "react";
import { gql } from "@apollo/client";
import { useApolloQuery } from "../../../hooks";

const GET_INDICATOR_CATEGORIES = gql`
  query GetIndicatorCategories {
    indicatorCategories {
      id
      name
    }
  }
`;

const policyFormOptionsQueryDocument = gql`
  query policyFormOptionsQuery {
    countryOptions: countries {
      value: id
      label: name
    }
    themeOptions: themes {
      value: id
      label: title
    }
  }
`;

function CompositeIndex() {
  const [value, setValue] = useState(1);

  const { translator } = useLanguageTranslator();

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const tabStyles = (active: boolean) => ({
    backgroundColor: active ? "#F6A000" : "#E5E5EA",
    color: active ? "white !important" : "#989C9F",
    width: "50%",
  });

  const { data: indicatorCategoriesData = [] }: any = useApolloQuery({
    queryDocument: GET_INDICATOR_CATEGORIES,
    isPrivateCall: true,
  });

  const { data } = useApolloQuery({
    queryDocument: policyFormOptionsQueryDocument,
  });

  return (
    <div style={{ padding: "0px 20px" }}>
      <Grid
        container
        px={4}
        my={2}
        py={3}
        sx={{ backgroundColor: "#ffffff", borderRadius: "10px" }}
      >
        <Grid item xs={12} md={6} lg={7}>
          <Typography variant="h1" fontSize={18} sx={{ fontWeight: "bold" }}>
            {translator("My Custom Indicators")}
          </Typography>
          <Typography variant="h2" fontSize={12} fontWeight={200} mt={1}>
            {translator("Compare indices over time")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <Box>
            <Tabs value={value} onChange={handleChange} sx={{ width: "100%" }}>
              <Tab
                value={1}
                label={translator("Country Index")}
                sx={{
                  ...tabStyles(value === 1),
                }}
              />
              <Tab
                value={2}
                label={translator("Category Index")}
                sx={tabStyles(value === 2)}
              />
            </Tabs>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={12}
          md={6}
          lg={12}
          sx={{ backgroundColor: "white", borderRadius: "10px" }}
          py={5}
        >
          <Box role="tabpanel" sx={{ height: "90dvh" }} hidden={value === 1}>
            <CategoryIndex
              switchHandler={() => setValue(1)}
              filtersData={{ indicatorCategoriesData, data }}
            />
          </Box>
          <Box role="tabpanel" sx={{ height: "90dvh" }} hidden={value !== 1}>
            <CountryIndex
              switchHandler={() => setValue(2)}
              filtersData={{ indicatorCategoriesData, data }}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export { CompositeIndex };
